import { Box } from "@mui/material";

import BaseHeader from "@/App/BaseApp/Header/BaseHeader";

import { HeaderAppLogo } from "./components/HeaderAppLogo";
import { NavToggleButton } from "./components/NavToggleButton";

export default function Header() {
  return (
    <BaseHeader
      mainContent={
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            py: 2,
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              zIndex: 2,
              mr: { xxs: 0, md: 3 },
            }}
          >
            {/* Nav toggle */}
            <NavToggleButton />

            {/* App logo */}
            <HeaderAppLogo />
          </Box>
        </Box>
      }
    />
  );
}
